module.exports = __webpack_public_path__ + "9850db4438f6ca2d3535fdc2091a9afa.svg";